import { execute } from '@lib/graphql/execute'
import { graphql } from '@lib/graphql/gql'
import { CustomerActivateInput } from '@lib/graphql/graphql'
import { MutationConfig } from '@lib/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getCustomerQueryOptions } from './get-customer'

// Add an extraGroups array that lists the groups requiring extra info.

export type CustomerActivationError =
  | { code: 'CustomerNotFoundError'; field: string; message: string }
  | { code: 'InvalidTokenError'; field: string; message: string }

export type CustomerActivateResponse = {
  customer: {
    id: string
  } | null
  customerAccessToken: {
    accessToken: string
    refreshToken: string
  } | null
  errors: CustomerActivationError[]
}

const customerActivateMutationDocument = graphql(`
  mutation CustomerActivate($input: CustomerActivateInput!) {
    customerActivate(input: $input) {
      customer {
        id
      }
      customerAccessToken {
        accessToken
        refreshToken
      }
      errors {
        code: __typename
        ... on UserError {
          message
        }
      }
    }
  }
`)

export const customerActivate = async ({
  input,
}: {
  input: CustomerActivateInput
}) => {
  const activateResponse = await execute(customerActivateMutationDocument, {
    input,
  })

  return activateResponse
}

type UseCustomerCreateOptions = {
  mutationConfig?: MutationConfig<typeof customerActivate>
}

export const useCustomerActivate = ({
  mutationConfig,
}: UseCustomerCreateOptions = {}) => {
  const queryClient = useQueryClient()

  const { onSuccess, ...restConfig } = mutationConfig || {}

  return useMutation({
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: getCustomerQueryOptions().queryKey,
      })
      onSuccess?.(...args)
    },
    ...restConfig,
    mutationFn: customerActivate,
  })
}
